<template>
<div>
<div v-if="isLoading" class="loading">Loading&#8230;</div>

<div @click="show_details=!show_details" class="columns is-multiline is-gapless" :class="return_style_selected()">
                
            <!-- <div class="column is-2">          
                <figure class="image is-32x32">
                    <img :src="return_pic(stud.student_PhotoPath)" onerror="javascript:this.src='https://space-zytco.nyc3.digitaloceanspaces.com/photos/noImage.png'" alt="....">
                </figure>     
            </div> -->



<div class="column is-2" :class="return_style_status()">   
    <div class="columns is-multiline is-gapless">      
        <div class="column is-12 has-text-weight-bold is-uppercase">&nbsp;{{stud.student_lNAME}}</div>
        <div class="column is-12 is-size-7 is-uppercase" style="margin-top:-.5em;">&nbsp; {{stud.student_fNAME}}</div>
        
    </div>
</div>

<div class="column is-2" :class="return_style_status()">   
    <div class="columns is-multiline is-gapless">      
        <div class="column is-12 has-text-weight-bold has-text-centered" style=""> {{stud.student_GRPCODE}}&nbsp;</div>
        <div class="column is-12 is-size-7 is-uppercase has-text-centered" style="margin-top:-.5em;">&nbsp; {{stud.student_CodePerm}}</div>
        
    </div>
</div>

<div class="column is-2" :class="return_style_status()">   
    <div class="columns is-multiline is-gapless">      
        <div class="column is-12 has-text-weight-bold has-text-centered" style=""> {{stud.student_CreateDate | moment("MMM DD YY")}}&nbsp;</div>
        <!-- <div class="column is-12 is-size-7 is-uppercase has-text-centered" style="margin-top:-.5em;">&nbsp; {{stud.student_CodePerm}}</div> -->
        
    </div>
</div>

<div class="column is-3"> 
<div class="columns is-centered is-gapless mt-2">
    <div class="column is-3 colBorderRight"> <a class="button is-small is-fullwidth has-background-grey-lighter has-text-black" @click="tran_click_did()">DID</a> </div>
    <div class="column is-3 colBorderRight"> <a class="button is-small is-fullwidth has-background-grey-lighter has-text-black" @click="tran_click_cit()">CIT</a> </div>
    <div class="column is-3"> <a class="button is-small is-fullwidth has-background-grey-lighter has-text-black" @click="tran_click_adr()">ADR</a> </div>
</div></div>

 
<!-- stud.student_GRPCODE -->
<div class="column is-3">

<!-- ** SELECTED  :class="return_style_selected()" -->
<div v-if="is_selected" class="columns is-gapless">    
    <div class="column is-12"> <a class="button is-fullwidth has-background-grey-lighter has-text-info" @click="tran_click('IPR')"><span class="icon is-small"><i class="fas fa-undo"></i></span></a> </div>
</div>
          
<div v-else class="columns is-gapless is-centered">  
<div v-if="tran_status == 'PENDING'" class="column is-6 is-size-7"> <a class="button is-fullwidth has-background-warning-light has-text-black" @click="tran_cancel()"><span class="icon is-small"><i class="fas fa-clock"></i></span>&nbsp;&nbsp;EXPÉDIÉ</a> </div> 

<div v-else-if="tran_status == 'NEED'" class="column is-6"> <a class="button is-fullwidth has-text-success"   @click="tran_click()"><span class="icon is-small"><i class="fas fa-plus-circle"></i></span></a> </div>
<div v-else-if="tran_status == 'ERROR'" class="column is-6"><a class="button is-fullwidth has-background-danger-light has-text-success" @click="tran_click()"><span class="icon is-small"><i class="fas fa-plus-circle"></i></span></a>  </div>
<div v-else class="column is-8"><div class="columns is-gapless">
    <div class="column is-6"> <a class="button is-fullwidth has-background-white has-background-white has-text-black" @click="tran_modify()"><span class="icon is-small"><i class="fas fa-edit"></i></span></a> </div>
    <div class="column is-6"> <a class="button is-fullwidth has-background-white has-background-white has-text-danger" @click="tran_cancel()"><span class="icon is-small"><i class="fas fa-user-times"></i></span></a> </div>
</div></div>


    <!-- <div v-else-if="tran_status == 'ERROR'" class="column is-3"> <a class="button is-fullwidth has-background-white has-text-success" @click="tran_click()"><span class="icon is-small"><i class="fas fa-plus-circle"></i></span></a> </div>
    <div v-if="tran_type == 'IPR'" class="columns is-gapless">
        <div class="column is-12"> <a class="button is-fullwidth has-text-danger"  :class="return_style_selected()" @click="tran_cancel()"><span class="icon is-small"><i class="fas fa-user-times"></i></span></a> </div>
    </div>
    <div v-else class="columns is-gapless">
        <div class="column is-6 has-background-danger"> <a class="button is-fullwidth has-background-light has-text-black" @click="tran_modify()"><span class="icon is-small"><i class="fas fa-edit"></i></span></a> </div>
        <div class="column is-6"> <a class="button is-fullwidth has-text-danger"  :class="return_style_selected()" @click="tran_cancel()"><span class="icon is-small"><i class="fas fa-user-minus"></i></span></a> </div>
    </div> -->

</div></div>
<!-- END BUTTONS       -->

<div v-if="tran_status == 'ERROR'"  class="column is-12">
    <div class="columns is-multiline is-gapless colBorder"  v-for="(data,index) in data_details" :key="index">
        <div v-if="data.tranError_DESC" class="column is-12 isLabel is-size-7 has-text-weight-bold">{{data.fileTran_DATE}}</div>
        <div v-if="data.tranError_DESC" class="column is-12 colNotes is-size-7 has-text-weight-bold" style="margin:.4em;">{{data.tranError_DESC}}</div>
    </div>
</div>
<!-- END SHOWING ERROR  -->

</div>
<!-- END MAIN COLUMN  -->

</div>
</template>

<script>
import moment from 'moment';
//, 'sess', 'ann'
export default {
        props: [ 'stud', 'files', 'tran_type', 'is_selected_ipr'],
        components: {  },

        data() {
            return {
                 isLoading:false,
                 tran_status:'',
                 is_selected:this.is_selected_ipr, 


is_selected_did:false,
is_selected_cit:false,
is_selected_adr:false,


tran_selected:'', 

                 tran_count:0,
                 show_details:false,
                 data_details:[],
            }
        },

created() {


var filter_final = this.files.filter((data) => data.student_ID === this.stud.studID)
console.log('-------------------' + this.stud.studID + '----------------------------')
console.log(filter_final)


    this.chk_Tran()
//console.log(this.files.findIndex(x => x.student_ID === this.stud.studID))

 

}, // END CREATED

methods : { 

hl_button:function(colour) {

switch(this.tran_selected) {
  case x:
    // code block
    break;
  case y:
    // code block
    break;
  default:
    // code block
}

}, // END hl BUTTON

tran_click_did:function() {

    this.tran_selected = 'DID' // SET THE TYPE
    if (this.is_selected_did) {this.is_selected_did = false; this.tran_cancel()}
    else {this.is_selected_did = true; this.tran_create()}
},
tran_click_cit:function() {

    this.tran_selected = 'CIT' // SET THE TYPE
    if (this.is_selected_cit) {this.is_selected_cit = false; this.tran_cancel()}
    else {this.is_selected_cit = true; this.tran_create()}
},
tran_click_adr:function() {

    this.tran_selected = 'ADR' // SET THE TYPE
    if (this.is_selected_adr) {this.is_selected_adr = false; this.tran_cancel()}
    else {this.is_selected_adr = true; this.tran_create()}
},



tran_click:function(tran) {

    // SET THE TYPE
    this.tran_selected = tran

    if (!this.is_selected)
    {this.is_selected = true; this.tran_create()}
    else {this.tran_cancel()}
},

tran_create:function() {
     
    this.$emit("emit_tran_add", this.stud, this.tran_selected, 'C'  )
      
},
tran_cancel:function() {
    this.$emit("emit_tran_remove", this.stud.student_ID[0], this.tran_selected)
    this.is_selected = false;
},


tran_modify:function() {
    this.is_selected = true;
},


chk_Tran:function() {

    // var self = this;
    // var filter_final = this.files.filter(function(data) {return data.student_ID == self.stud.studID; });


    var filter_final = this.files.filter((data) => data.student_ID === this.stud.studID)

    this.tran_status = "NEED" // DEFAULT
    for (var i = 0; i < filter_final.length; i++) {
        // CHECK IF OUT 
        if (filter_final[i].fileTran_STATUS == 'PENDING') {
            this.tran_status = 'PENDING'
            return
        }

        // CHECK IF OK
        if (!filter_final[i].tran_bERROR) {
            this.tran_status = 'GOT'
            return
        }
        // CHECK IF ERROR
        if (filter_final[i].tran_bERROR == true) {
            this.tran_status = 'ERROR' 
            // this.tranError_DESC += filter_final[i].tranError_DESC.replace('| ','') + " ---- "

console.log(filter_final[i])


    this.data_details.push(
        {tranError_DESC:filter_final[i].tranError_DESC, fileTran_DATE: moment(filter_final[i].fileTran_DATE).format('ddd MMM do YYYY')}
    )



        }
    }

},


chk_Tran_XXX:function() {

var self = this;
// alert(self.stud.student_ID[0])
var arrDetails = this.files.filter(function(data) {return data.student_ID == self.stud.student_ID[0]; });

// alert(arrDetails.length)
// console.log(arrDetails)

this.tran_count = arrDetails.length
var i; for (i = 0; i < arrDetails.length; i++) {
    this.data_details.push(
        {tranError_DESC:arrDetails[i].tranError_DESC, fileTran_DATE: moment(arrDetails[i].fileTran_DATE).format('ddd MMM do YYYY')})
} // END FOR

//this.isLoading=true; 
     var index = this.files.findIndex(x => x.student_ID == this.stud.student_ID[0])

console.log('INDEX :::: ' + index)

     if (index > -1) {
        //CHECK IF WAITING/ERROR
        console.log('error: ' + this.files[index].tran_bERROR)
            if (this.files[index].tran_bERROR == true) {
            this.tran_status = 'ERROR'
                } else {
            this.tran_status = 'GOT'
            }
    } else {
        // NOT SENT YET
        this.tran_status = 'NEED'
    }
//this.isLoading=false;

},

return_pic:function(pic) {
    return 'https://space-zytco.nyc3.digitaloceanspaces.com/photos/'+pic
},

return_style_status:function() {
    if (this.tran_status == 'PENDING') {
        return 'has-background-warning-light has-text-black' }
    else if (this.tran_status == 'GOT') { 
        return 'has-background-success has-text-white' }
    else if (this.tran_status == 'ERROR') {
        return 'has-background-danger has-text-white' 
    } else {
        return 'has-background-white'
    }
},

return_style_selected:function() {
    if (this.is_selected) {
        return 'has-background-primary'
    } else {
        return 'has-background-white'
    }
},


}, // END METHODS


}
</script>